export const REQUEST_EDIT_APPLICANT_ADDRESS_MODAL_QA_NAME =
  'requestEditApplicantAddress'

export const REQUEST_EDIT_APPLICANT_ADDRESS_MODAL_FIELD_NAME_OWNER = 'owner'

export const REQUEST_EDIT_APPLICANT_ADDRESS_MODAL_FIELD_NAME_BUILDING =
  'building'

export const REQUEST_EDIT_APPLICANT_ADDRESS_MODAL_FIELD_NAME_FLAT = 'flat'

export const REQUEST_EDIT_APPLICANT_ADDRESS_MODAL_FIELD_LABEL_KEYS = {
  [REQUEST_EDIT_APPLICANT_ADDRESS_MODAL_FIELD_NAME_BUILDING]:
    'RequestProfile.EditOwnerAndAddressModalBuildingLabelKey',
  [REQUEST_EDIT_APPLICANT_ADDRESS_MODAL_FIELD_NAME_FLAT]:
    'RequestProfile.EditOwnerAndAddressModalFlatLabelKey',
  [REQUEST_EDIT_APPLICANT_ADDRESS_MODAL_FIELD_NAME_OWNER]:
    'RequestProfile.EditOwnerAndAddressModalApplicantLabelKey',
  action: 'RequestProfile.EditOwnerAndAddressModalActionLabelKey',
}

export const REQUEST_EDIT_APPLICANT_ADDRESS_MODAL_FIELD_PLACEHOLDER_KEYS = {
  [REQUEST_EDIT_APPLICANT_ADDRESS_MODAL_FIELD_NAME_BUILDING]:
    'RequestProfile.EditOwnerAndAddressModalBuildingPlaceholderKey',
  [REQUEST_EDIT_APPLICANT_ADDRESS_MODAL_FIELD_NAME_FLAT]:
    'RequestProfile.EditOwnerAndAddressModalFlatPlaceholderKey',
  [REQUEST_EDIT_APPLICANT_ADDRESS_MODAL_FIELD_NAME_OWNER]:
    'RequestProfile.EditOwnerAndAddressModalApplicantPlaceholderKey',
}
